<template>
  <div>
    <div class="vx-card" v-if="loaded">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-2">
          <div class="vx-row lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mr-5">
            <div>{{ $t("Firstname") }} :</div>
            <div class="mr-2">{{ individualInfo.firstName }}</div>
          </div>
          <div class="vx-row lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <div>{{ $t("Lastname") }} :</div>
            <div class="mr-2">{{ individualInfo.lastName }}</div>
          </div>
          <div class="vx-row lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <div>{{ $t("SocialSecurityNumber") }} :</div>
            <div class="mr-2">{{ individualInfo.socialSecurityNumber }}</div>
          </div>
          <div class="vx-row lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <div>{{ $t("BirthCertificateNumber") }} :</div>
            <div class="mr-2">{{ individualInfo.birthCertificateNumber }}</div>
          </div>
          <div class="vx-row mt-5 lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mr-5">
            <div>{{ $t("ShopName") }} :</div>
            <div class="mr-2">{{ individualInfo.storeName }}</div>
          </div>
          <div class="vx-row mt-5 lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <div>{{ $t("AgentOwnerNumber") + " (نام کاربری)" }} :</div>
            <div class="mr-2">
              {{ individualInfo.agentOwnerQuery.agentOwnerName }}
            </div>
          </div>
          <div class="vx-row lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-5">
            <div>{{ $t("PhoneArea") }} :</div>
            <div
              v-for="(phone, index) in individualInfo.agentPhones"
              class="mr-2"
            >
              {{ phone.area }}
              <span v-if="individualInfo.agentPhones.lenght === index + 1">
                |
              </span>
            </div>
          </div>
          <div class="vx-row lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-5">
            <div>{{ $t("PhoneNumber") }} :</div>
            <div
              v-for="(phone, index) in individualInfo.agentPhones"
              class="mr-2"
            >
              {{ phone.number }}
              <span v-if="individualInfo.agentPhones.lenght === index + 1">
                |
              </span>
            </div>
          </div>
          <div class="vx-row mt-5 lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mr-5">
            <div>{{ $t("Email") }} :</div>
            <div class="mr-2">{{ individualInfo.emailAddress }}</div>
          </div>
          <div class="vx-row mt-5 lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <div>{{ $t("Province") }} :</div>
            <div class="mr-2">
              {{
                allProvinces &&
                individualInfo.addressInfo[0].agentProvinceInfo.provinceId
                  ? allProvinces.filter(
                      (x) =>
                        x.id ==
                        individualInfo.addressInfo[0].agentProvinceInfo
                          .provinceId
                    )[0].name
                  : ""
              }}
            </div>
          </div>
          <div class="vx-row mt-5 lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <div>{{ $t("City") }} :</div>
            <div
              v-for="(address, index) in individualInfo.addressInfo"
              class="mr-2"
            >
              {{
                address.agentCityInfo.cityId && allCities
                  ? allCities.filter(
                      (x) => x.id == address.agentCityInfo.cityId
                    )[0].name
                  : ""
              }}
              <span v-if="individualInfo.addressInfo.lenght === index + 1">
                |
              </span>
            </div>
          </div>
          <div class="vx-row mt-5 lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
            <div>{{ $t("PostalCode") }} :</div>
            <div
              v-for="(address, index) in individualInfo.addressInfo"
              class="mr-2"
            >
              {{ address.postalCode }}
              <span v-if="individualInfo.addressInfo.lenght === index + 1">
                |
              </span>
            </div>
          </div>
          <span class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-5">
            <label class="vs-select--label">{{ $t("EconomicCode") }}</label>
            <div
              class="vx-row w-full p-0 mx-0 vs-input--input vs-input--input.normal"
            >
              <vs-input
                class="vs-input-no-border w-1/3"
                v-model="economicCodeSpecific"
                name="economicCode"
                maxlength="4"
                disabled
                placeholder="کد اقتصادی"
              />
              <vs-input
                class="vs-input-no-border w-2/3"
                v-model="individualInfo.socialSecurityNumber"
                name="socialSecurityNumber"
                disabled
              />
            </div>
          </span>
          <div class="vx-row lg:w-3/4 md:w-2/3 w-full mt-10 mr-5">
            <label class="vs-select--label">{{ $t("Address") }} :</label>
            <div
              v-for="(address, index) in individualInfo.addressInfo"
              class="mr-2"
            >
              {{ address.address }}
              <span v-if="individualInfo.addressInfo.lenght === index + 1">
                |
              </span>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-checkbox
              disabled
              :checked="
                individualInfo.individualAgentTaxInfoQuery.isForeignSubjects
              "
              v-model="
                individualInfo.individualAgentTaxInfoQuery.isForeignSubjects
              "
              class="px-3"
              >{{ $t("NotIranianCitizen") }}
            </vs-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-card mt-3">
      <div class="vx-card__header">
        <div class="vx-card__title">
          <h4>{{ $t("TaxInfo") }}</h4>
        </div>
      </div>
      <div class="vx-card__body card-body" v-if="loaded">
        <div class="vx-row mb-2">
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <label class="vs-select--label">{{ $t("Province") }}</label>
            <v-select
              label="name"
              disabled
              :options="allProvincesOfTadbir"
              name="provinceOfTadbir"
              :reduce="(x) => x.id"
              v-validate="{ required: 'true' }"
              ref="provinceOfTadbirListSelect"
              v-model="individualInfo.individualAgentTaxInfoQuery.provinceId"
              @input="selectProvinceOfTadbir"
              :value="
                allProvincesOfTadbir &&
                individualInfo.individualAgentTaxInfoQuery.provinceId
                  ? allProvincesOfTadbir.filter(
                      (x) =>
                        x.id ==
                        individualInfo.individualAgentTaxInfoQuery.provinceId
                    )[0].name
                  : ''
              "
              :clearable="false"
              dir="rtl"
            >
            </v-select>

            <span
              class="text-danger text-sm"
              v-show="errors.has('provinceOfTadbir')"
              >{{ errors.first("provinceOfTadbir") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <label class="vs-select--label mt-4">{{ $t("City") }}</label>
            <v-select
              label="name"
              name="cityOfTadbir"
              :options="allCitiesOfTadbir"
              disabled
              :reduce="(x) => x.id"
              v-model="individualInfo.individualAgentTaxInfoQuery.cityId"
              v-validate="{ required: 'true' }"
              :clearable="true"
              ref="cityOfTadbirListSelect"
              @input="selectCityOfTadbir"
              dir="rtl"
              :value="
                individualInfo.individualAgentTaxInfoQuery.cityId &&
                allCitiesOfTadbir
                  ? allCitiesOfTadbir.filter(
                      (x) =>
                        x.id ==
                        individualInfo.individualAgentTaxInfoQuery.cityId
                    )[0].name
                  : ''
              "
            >
            </v-select>

            <span
              class="text-danger text-sm"
              v-show="errors.has('cityOfTadbir')"
              >{{ errors.first("cityOfTadbir") }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";

const dict = {
  custom: {
    fName: {
      required: "لطفا نام را وارد نمایید.",
    },
    lName: {
      required: "لطفا نام خانوادگی را وارد نمایید.",
    },
    idNumber: {
      required: "لطفا کدملی را وارد نمایید.",
      regex: "کدملی نامعتبر می باشد.",
      digits: "کدملی نامعتبر می باشد.",
    },
    certificateNumber: {
      required: "لطفا شماره شناسنامه را وارد نمایید.",
      regex: "شماره شناسنامه نامعتبر می باشد.",
    },
    email: {
      email: "پست الکترونیک نامعتبر می باشد.",
    },
    area: {
      regex: "پیش شماره نامعتبر می باشد.",
    },
    number: {
      regex: "شماره تلفن نامعتبر می باشد.",
    },
    postalCode: {
      regex: "کدپستی نامعتبر می باشد.",
      digits: "کدپستی نامعتبر می باشد.",
    },
    economicCode: {
      required: "لطفا کد اقتصادی را وارد نمایید.",
      regex: "کد اقتصادی نامعتبر می باشد.",
      digits: "کد اقتصادی نامعتبر می باشد.",
    },
    province: {
      required: "لطفا استان را انتخاب نمایید.",
    },
    city: {
      required: "لطفا شهر را انتخاب نمایید.",
    },
    store: {
      required: "لطفا نام مغازه را وارد نمایید.",
    },
    owner: {
      required: "لطفا شماره موبایل مالک اصلی را وارد نمایید.",
      regex: "شماره موبایل مالک اصلی نامعتبر می باشد.",
      max: "شماره موبایل مالک اصلی وارد شده معتبر نیست.",
      min: "شماره موبایل مالک اصلی وارد شده معتبر نیست.",
    },
    provinceOfTadbir: {
      required: "لطفا استان را در قمست مشخصات مالیاتی انتخاب نمایید.",
    },
    cityOfTadbir: {
      required: "لطفا شهر را در قمست مشخصات مالیاتی انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  data() {
    return {
      titleTaxTypes: [
        { name: "خصوصی", id: 0 },
        { name: "دولتی", id: 1 },
        { name: "مشارکت مدنی", id: 2 },
      ],
      typeTaxTypes: [
        { name: "وزارت", id: 1 },
        { name: "موسسه دولتی", id: 2 },
        { name: "شرکت دولتی", id: 3 },
        { name: "سایر دستگاه‌های دولتی", id: 4 },
        { name: "نهادهای عمومی غیر‌دولتی", id: 5 },
        { name: "بخش خصوصی", id: 6 },
        { name: "سایر", id: 7 },
      ],
      individualInfo: {},
      individualInfoForApi: {},
      economicCodeSpecific: "",
      disabled: false,
      loaded: false,
    };
  },
  mounted() {
    this.fetchProvinces();
    this.fetchProvincesOfTadbir();
    this.load();
  },
  computed: {
    ...mapGetters({
      allProvinces: "country/provinceList",
      allCities: "country/cityList",
      locationInfo: "country/details",
      individual: "parties/agentDetails",
      allProvincesOfTadbir: "country/provinceOfTadbirList",
      allCitiesOfTadbir: "country/cityOfTadbirList",
    }),
  },
  methods: {
    ...mapActions({
      fetchProvinces: "country/fetchProvinces",
      fetchCitiesById: "country/fetchCitiesById",
      fetchSingleAgent: "parties/fetchSingleAgent",
      updateIndividual: "individual/updateAgent",
      fetchProvincesOfTadbir: "country/fetchProvincesOfTadbir",
      fetchCitiesOfTadbirById: "country/fetchCitiesOfTadbirById",
    }),
    selectProvince(province) {
      this.individualInfo.addressInfo[0].agentCityInfo.cityId = null;
      this.individualInfo.addressInfo[0].agentCityInfo.cityName = "";

      this.individualInfo.addressInfo[0].agentProvinceInfo.provinceId =
        province.id;
      this.individualInfo.addressInfo[0].agentProvinceInfo.provinceName =
        province.name;
      this.fetchCitiesById(province.id);
      if (this.$refs.cityListSelect) {
        this.$refs.cityListSelect[0].clearSelection();
      }
    },
    selectProvinceOfTadbir(provinceId) {
      this.individualInfo.individualAgentTaxInfoQuery.cityId = null;
      this.individualInfo.individualAgentTaxInfoQuery.provinceId = provinceId;
      this.fetchCitiesOfTadbirById(provinceId);
      if (this.$refs.cityOfTadbirListSelect) {
        this.$refs.cityOfTadbirListSelect.clearSelection();
      }
    },
    selectCity(city) {
      if (city) {
        this.individualInfo.addressInfo[0].agentCityInfo.cityId = city.cityId;
        this.individualInfo.addressInfo[0].agentCityInfo.cityName =
          city.cityName;
      }
    },
    selectCityOfTadbir(cityId) {
      if (cityId) {
        this.individualInfo.individualAgentTaxInfoQuery.cityId = cityId;
      }
    },
    createModelForApi(individualInfo) {
      this.individualInfoForApi = {
        emailAddress: individualInfo.emailAddress,
        agentOwnerName: individualInfo.agentOwnerQuery.agentOwnerName,
        economicCode: this.economicCodeSpecific,
        addressesInfoCommand: individualInfo.addressInfo,
        agentPhonesCommand: individualInfo.agentPhones,
        id: individualInfo.id,
        firstname: individualInfo.firstName,
        lastname: individualInfo.lastName,
        socialSecurityNumber: individualInfo.socialSecurityNumber,
        birthCertificateNumber: individualInfo.birthCertificateNumber,
        storeName: individualInfo.storeName,
        individualAgentTaxInfo: individualInfo.individualAgentTaxInfoQuery,
      };
    },
    load() {
      var id = this.$route.params.id;
      this.fetchSingleAgent(id).then(() => {
        this.individualInfo = JSON.parse(JSON.stringify(this.individual));
        if (this.individualInfo.economicCode) {
          this.economicCodeSpecific =
            this.individualInfo.economicCode.slice(-4);
        }
        if (
          this.allCitiesOfTadbir &&
          this.allCities &&
          this.allProvinces &&
          this.allProvincesOfTadbir
        ) {
          this.fetchCitiesById(
            this.individualInfo.addressInfo[0].agentProvinceInfo.provinceId
          ).then(() => {
            this.fetchCitiesOfTadbirById(
              this.individualInfo.individualAgentTaxInfoQuery.provinceId
            ).then(() => {
              this.loaded = true;
            });
          });
        }
      });
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disabled = true;
          this.createModelForApi(this.individualInfo);
          this.individualInfoForApi.economicCode =
            this.individualInfoForApi.socialSecurityNumber.concat(
              this.economicCodeSpecific
            );
          this.updateIndividual(this.individualInfoForApi).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              this.$router.go(-1);
            });
            this.$validator.reset();
          });
        } else {
          // form have errors
        }
      });
    },
    cancel() {
      this.$router.push("/Agents/Index");
    },
  },
  components: {
    "v-select": vSelect,
  },
};
</script>
